"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sign = void 0;
function sign(registry, signerPair, u8a, options) {
    const encoded = u8a.length > 256
        ? registry.hash(u8a)
        : u8a;
    return signerPair.sign(encoded, options);
}
exports.sign = sign;
